import { render } from "./ContactView.vue?vue&type=template&id=a80d592c&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=a80d592c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a80d592c"]])

export default __exports__